var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statusBox"},[_c('div',{class:[
      _vm.value == 0 ? 'red' : _vm.value == 1 ? 'green' : 'yellow',
      'status_icon' ]}),_c('span',{class:[_vm.value == 0 ? 'redColor' : _vm.value == 1 ? 'greenColor' : 'yellowColor']},[_vm._v(" "+_vm._s(_vm.value == 0 ? "待激活" : _vm.value == 1 ? "已激活" : "——"))])])}
var staticRenderFns = []

export { render, staticRenderFns }